import React from "react"
import { IconProps } from "./interfaces/IconProps.interface"

const Exclamation = (props: IconProps) => {
    const { color = "#0E0E0E", ...rest } = props

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...rest}>
            <path d="M11 17H13V15H11V17Z" fill={color} />
            <path d="M11 13H13L13 7H11L11 13Z" fill={color} />
        </svg>
    )
}

export default Exclamation
